<template>
	<div class="user-container">
		<div class="content">
			<div class="navbar-container">
				<TopNavbar is-in-user-section
						   :base-path="topNavbarBasePath"
						   :show-micro-sidebar="showSuperSidebar"
						   :sidebar-items="showSuperSidebar ? microSidebarItems : null"
						   ref="top-navbar">
					<template #content>
						<div class="row navbar-slot-content">
							<div class="navbar-left-side">
								<h3>{{ currSectionName }}</h3>
							</div>
							<div class="navbar-right-side">
								<AppButtonIcon v-if="showFiltersIcon && currentPath === '/analytics'" class="nav-filters-btn" @click="toggleFilters"
											   :active="!collapsedSelectors" prevent-change icon-name="icon-filters"/>
							</div>
						</div>
					</template>
				</TopNavbar>
			</div>
			<div class="main-content">
				<router-view />
			</div>
		</div>
	</div>
</template>

<script>
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import TopNavbar from "@/console-new/components/shared/TopNavbar.vue";

import {useLanguageStore} from "@/shared/stores";
import { computed } from 'vue';
import {useSuperStore} from "@/user/stores";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let superStore = useSuperStore();
		return {getString: languageStore.getString, superStore}
	},
	name: "UserContainer",
	components: {AppButtonIcon, TopNavbar},
	data() {
		return {
			basePath: "/",
			currentTab: 0,
			collapsedSelectors: false,
			showFiltersIcon: false,
		}
	},
	provide() {
		return {
			providedAction: computed(() => {
				return {
					toggleFilters: this.toggleFilters,
					collapsedSelectors: this.collapsedSelectors,
					toggleIconFilters: this.toggleIconFilters,
					showFiltersIcon: this.showFiltersIcon,
				}
			})
		}
	},
	computed: {
		showSuperSidebar() {
			return this.$route.path.startsWith('/super');
		},
		microSidebarItems() {
			return [
				{name: this.getString('administration'), icon: 'iconBusinessConsole', path: '/business'},
				{name: this.getString('invoices'), icon: 'iconInvoice', path: '/invoices', shown: this.superStore.isUltra || this.superStore.isMega},
				{name: this.getString('support'), icon: 'iconChatBot', path: '/chats'}
			];
		},
		topNavbarBasePath() {
			return this.showSuperSidebar ? '/super' : this.basePath;
		},
		currSectionName() {
			if (this.$route && this.$route.path) {
				if (this.$route.path.includes('/analytics')) {
					return this.getString('analytics');
				} else if (this.$route.path.includes('/super')) {
					return this.superStore.isUltra ? this.getString('ultra_user') : this.getString('super_user');
				} else if (this.$route.path.includes('/settings')) {
					return this.getString('settings');
				} else if (this.$route.path.includes('/overview-businesses')) {
					return this.getString('businesses_overview');
				} else if (this.$route.path.includes('/businesses')) {
					return this.getString('businesses_management');
				}
			}
			return this.getString('user');
		},
		currentPath() {
			return this.$route.path;
		}
	},
	methods: {
		toggleFilters() {
			this.collapsedSelectors = !this.collapsedSelectors;
		},
		toggleIconFilters(newState = !this.showFiltersIcon) {
			this.showFiltersIcon = newState;
		},
	},
	mounted() {
		if(this.$route.path === "/") {
			this.$router.push("/analytics");
		}
	},
	watch: {
		$route(to) {
			if (to && to.path && to.path === "/") {
				this.$router.push("/analytics");
			}
		}
	},
}
</script>

<style lang="scss" scoped>
.user-container {
	display: flex;
	flex-direction: row;
	height: 100%;

	.content {
		width: 100%;
	}

	.main-content {
		width: 100%;
		height: calc(100% - 60px);
		padding: 0;
	}

	.navbar-container {
		z-index: 11;
		height: 60px;
		width: 100%;

		.navbar-slot-content {
			align-items: center;
			justify-content: space-between;
			height: 100%;
			padding: 0 10px;

			@media (max-width: 920px) {
				padding: 0 10px 0 2px;
			}
		}

	}

}
</style>